import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

// import HelloWorld from '@/components/index'
import HelloWorld from '@/components/index'
// 解决方案
import Solution from '@/components/solution/index'
import SolutionDetails from '@/components/solution/solutionDetails'
// 新闻
import News from '@/components/news/index'
import NewDetails from '@/components/news/newDetails'
// 园区动态
import Park from '@/components/park/index'
// 园区详情内容
import ParkDetails from '@/components/park/parkDetails'
// 园区详情
import AllPark from '@/components/park/allPark'
// 查看更多
import ParkDynamic from '@/components/park/parkDynamic'
// vr视频
import zengcaicloudVideo from '@/components/parkSwiper/zengcaicloudVideo'


// vr全景测试
import Veiws from '@/components/park/allMap/veiws'
// 测试VR
import VeiwsUrl from '@/components/park/VeiwsUrl'

// 我要打印
import print from '@/components/print/index'
// 我要打印-成果展示
import PrintResults from '@/components/print/printResults'
// 我要打印-打印材料
import PrintMaterial from '@/components/print/printMaterial'
// 我要打印-联系我们
import PrintContact from '@/components/print/printContact'
// 我要打印-商家列表页
import PrintHot from '@/components/print/printHot'
// 我要打印-热门服务列表页
import PrintList from '@/components/print/printList'
// 我要打印-商家详情页
import PrintDetails from '@/components/print/printDetails'
// 我要打印-服务商首页
import PrintServiceIndex from '@/components/print/printServiceIndex'
// 我要打印-服务详情页
import PrintServiceDetails from '@/components/print/printServiceDetails'
// 我要打印-服务商认证
import printServiceAuthentication from '@/components/print/printServiceAuthentication'
// 我要打印-下单页
import printPlaceAnOrder from '@/components/print/placeAnOrder'
// 我要打印-下单确认页
import printAffirmOrder from '@/components/print/printAffirmOrder'
// 我要打印-下单成功页
import printSendSuccess from '@/components/print/printSendSuccess'


// 设计市场-需求列表
import design from '@/components/design/index'
// 设计市场-评论
import DesignComments from '@/components/design/designComments'
// 设计市场-成果展示
import DesignResults from '@/components/design/designResults'
// 设计市场-需求详情页
import DesignDetails from '@/components/design/designDetails'
// 设计市场-设计师简介
import DesignIntroduction from '@/components/design/designIntroduction'
// 设计市场-设计师模型
import DesignModel from '@/components/design/designModel'
// // 设计市场-设计师列表
import DesignerList from '@/components/design/designerList'
// // 设计市场-需求列表
import DesignList from '@/components/design/designList'
// // 设计市场-发布需求
import DesignRelease from '@/components/design/designRelease'
// // 设计市场-设计师入驻
import DesignerIn from '@/components/design/designerIn'
// // 设计市场-活动列表页
import activeList from '@/components/design/activeList/activeList'
// // 设计市场-活动详情
import activeDetail from '@/components/design/activeList/activeDetail'
// // 设计市场-活动详情--参赛作品详情
import worksDetails from '@/components/design/activeList/worksDetails'
// // 设计市场-活动详情--获奖作品详情
import winDetails from '@/components/design/activeList/winDetails'
// // 设计市场-领导中心
import leaderList from '@/components/design/activeList/leaderList'

import productWork from '@/components/design/productWork'




// 模型库
import model from '@/components/model/index'
// 模型库详情页
import ModelDetails from '@/components/model/modelDetails'
// 模型库列表页
import ModelList from '@/components/model/modelList'
//模型2d转3d
import modelImage from '@/components/model/modelImage'

import enterpriseVeiws from '@/components/park/allMap/enterpriseVeiws'
// 3D商城
import mall from '@/components/threeShop/index'
// 3D商城-商品列表
import ShopGoodsList from '@/components/threeShop/shopGoodsList'
// 3D商城-商品详情
import ShopGoodDetails from '@/components/threeShop/shopGoodDetails'
import ShopAffirmOrder from '@/components/threeShop/shopAffirmOrder'
import ShopSendSuccess from '@/components/threeShop/shopSendSuccess'
// 3D商城-商城列表
import ShopMallList from '@/components/threeShop/shopMallList'
// 3D商城-商家入驻
import ShopServiceAuthentication from '@/components/threeShop/shopServiceAuthentication'

// 软件市场
import apps from '@/components/saas/index'
// 软件超市详情页
import SaasDetails from '@/components/saas/saasDetails'
// 软件超市列表页
import SaasList from '@/components/saas/saasList'

// 注册
import Registered from '@/components/registeredLogin/registeredIndex'
// 注册成功
import RegSuccess from '@/components/registeredLogin/regSuccess'
// 发布成功
import sendSuccess from '@/components/design/sendSuccess'
// 登录
import Login from '@/components/registeredLogin/loginIndex'
// 登录获取code空页面
import LoginCode from '@/components/registeredLogin/LoginCode'
// 忘记密码
import forgetPassword from '@/components/registeredLogin/forgetPassword'
//
import UserCenter from '@/components/registeredLogin/userCenter/index'
// 个人中心--实名认证
import CertificationCenter from '@/components/registeredLogin/certificationCenter/index'
// 个人中心--企业认证
import EnterCertification from '@/components/registeredLogin/certificationCenter/enterCertification'
// 个人中心--企业管理
import EnterpriseCenter from '@/components/registeredLogin/enterpriseCenter/index'
// 403页面
import Undefined from '@/components/undefined'
// 在线资讯
import onlineConsult from '@/components/header/onlineConsult'
// 帮助中心
import helpCenter from '@/components/helpCenter/helpCenter'
// 帮助中心详情
import helpCenterDetail from '@/components/helpCenter/helpCenterDetail'
// 购物车
import shopCar from '@/components/threeShop/shopCar'

// 商品下架
import shelves from '@/components/shelves/shelves'

// 积分活动
import integralActivities from '@/components/integral/integralActivities'
import activeShopGoodDetails from '@/components/integral/shopGoodDetails'
import activeShopAffirmOrder from '@/components/integral/shopAffirmOrder'
import activeShopSendSuccess from '@/components/integral/shopSendSuccess'

// 集采活动
import collectActivities from '@/components/collect/collectActivities'
import collectShopGoodDetails from '@/components/collect/shopGoodDetails'
import collectShopAffirmOrder from '@/components/collect/shopAffirmOrder'
import collectShopSendSuccess from '@/components/collect/shopSendSuccess'

// 3D建模大赛
import threeDModel from '@/components/activity/3DModel'


Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
}
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


let router = new Router({
    scrollBehavior: () => ({ y: 0 }),
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'home',
            // component:HelloWorld,
            component: resolve => require(['@/components/index'], resolve),
            children: [],
            meta: {
                title: '增材云—创意出发，打印无限可能！'
            }
        },
        {
            path: '/home',
            name: 'home',
            // component: HelloWorld,
            component: resolve => require(['@/components/index'], resolve),
            meta: {
                title: '增材云—创意出发，打印无限可能！'
            }
        },
        {
            path: '/solution',
            name: 'solution',
            component: Solution,
            meta: {
                title: '增材云—解决方案'
            }
        },
        {
            path: '/solutionDetails/:uuid',
            name: 'solutionDetails',
            component: SolutionDetails,
            meta: {
                title: '增材云—解决方案'
            }
        },
        {
            path: '/news',
            name: 'news',
            component: News,
            meta: {
                title: '3D打印行业资讯——增材云'
            }
        },
        {
            path: '/news/newDetails/:uuid',
            name: 'newDetails',
            component: NewDetails,
            meta: {
                title: '3D打印行业资讯——增材云'
            }
        },
        {
            path: '/park',
            name: 'park',
            component: Park,
            meta: {
                title: '增材云—园区生态'
            }
        },
        {
            path: '/parkDetails/:uuid',
            name: 'parkDetails',
            component: ParkDetails,
            meta: {
                title: '增材云—园区生态'
            }
        },
        {
            path: '/allPark/:uuid',
            name: 'allPark',
            component: AllPark,
            meta: {
                title: '增材云—园区生态'
            }
        },
        {
            path: '/parkDynamic/:uuid?',
            name: 'parkDynamic',
            component: ParkDynamic,
            meta: {
                title: '增材云—园区生态'
            }
        },
        {
            path: '/zengcaicloudVideo',
            name: 'zengcaicloudVideo',
            component: zengcaicloudVideo,
            meta: {
                title: '增材云—共享智能铸造产业创新中心'
            }
        },
        // vr全景测试
        {
            path: '/veiws/:uuid',
            name: 'veiws',
            component: Veiws,
            // component: () => import ('@/components/park/allMap/veiws'),
            hidden: true,
            meta: {
                title: '增材云—园区生态'
            }
        },
        // vr全景测试
        {
            path: '/VeiwsUrl',
            name: 'VeiwsUrl',
            component: VeiwsUrl,
            hidden: true,
            meta: {
                title: '增材云—园区生态'
            }
        },
        // 企业VR全景
        {
            path: '/enterpriseVeiws/:uuid',
            name: 'enterpriseVeiws',
            component: enterpriseVeiws,
            // component: () => import ('@/components/park/allMap/veiws'),
            hidden: true,
            meta: {
                title: '增材云—园区生态'
            }
        },
        // 我要打印
        {
            path: '/print',
            name: 'print',
            component: print,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-成果展示
        {
            path: '/printResults',
            name: 'printResults',
            component: PrintResults,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-打印材料
        {
            path: '/printMaterial',
            name: 'printMaterial',
            component: PrintMaterial,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-联系我们
        {
            path: '/printContact',
            name: 'printContact',
            component: PrintContact,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-热门服务列表页
        {
            path: '/printHot',
            name: 'printHot',
            component: PrintHot,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-商家列表页
        {
            path: '/printList',
            name: 'printList',
            component: PrintList,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-商家详情页
        {
            path: '/printDetails',
            name: 'printDetails',
            component: PrintDetails,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-服务商首页
        {
            path: '/printServiceIndex/:enterPriseId/:pageIndex?',
            name: 'printServiceIndex',
            component: PrintServiceIndex,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-服务详情页
        {
            path: '/printServiceDetails/:uuid',
            name: 'printServiceDetails',
            component: PrintServiceDetails,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-服务商认证
        {
            path: '/printServiceAuthentication',
            name: 'printServiceAuthentication',
            component: printServiceAuthentication,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-下单页
        {
            path: '/printPlaceAnOrder',
            name: 'printPlaceAnOrder',
            component: printPlaceAnOrder,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-下单确认页
        {
            path: '/printAffirmOrder/:printOrderUuid',
            name: 'printAffirmOrder',
            component: printAffirmOrder,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 我要打印-下单成功页
        {
            path: '/printSendSuccess/:orderCode?/:uuid?',
            name: 'printSendSuccess',
            component: printSendSuccess,
            meta: {
                title: '增材云—我要打印'
            }
        },
        // 设计市场-需求列表
        {
            path: '/design',
            name: 'design',
            component: design,
            meta: {
                title: '增材云—设计市场'
            }
        },
        // 设计市场-评论
        {
            path: '/designComments',
            name: 'designComments',
            component: DesignComments,
            meta: {
                title: '增材云—设计市场'
            }
        },
        // 设计市场-成果展示
        {
            path: '/designResults',
            name: 'designResults',
            component: DesignResults,
            meta: {
                title: '增材云—设计市场'
            }
        },
        // 设计市场-需求详情页
        {
            path: '/designDetails/:uuid',
            name: 'designDetails',
            component: DesignDetails,
            meta: {
                title: '增材云—设计市场'
            }
        },
        // 设计市场-设计师简介
        {
            path: '/designIntroduction',
            name: 'designIntroduction',
            component: DesignIntroduction,
            meta: {
                title: '增材云—设计市场'
            }
        },
        // 设计市场-设计师模型
        {
            path: '/designModel/:uuid',
            name: 'designModel',
            component: DesignModel,
            meta: {
                title: '增材云—设计市场'
            }
        },
        // 设计市场-设计师列表
        {
            path: '/designerList',
            name: 'designerList',
            component: DesignerList,
            meta: {
                title: '增材云—设计市场'
            }
        },
        // 设计市场-需求列表
        {
            path: '/designList',
            name: 'designList',
            component: DesignList,
            meta: {
                title: '增材云—设计市场'
            }
        },
        // 设计市场-发布需求
        {
            path: '/designRelease',
            name: 'designRelease',
            component: DesignRelease,
            meta: {
                title: '增材云-发布需求'
            }
        },
        // 设计市场-设计师入驻
        {
            path: '/designerIn',
            name: 'designerIn',
            component: DesignerIn,
            meta: {
                title: '增材云-设计师认证'
            }
        },
        // 设计市场-活动列表页
        {
            path: '/activeList',
            name: 'activeList',
            component: activeList,
            meta: {
                title: '增材云-活动列表页'
            }
        },
        // 设计市场-活动列表页
        {
          path: '/activeDetail/:uuid?',
          name: 'activeDetail',
          component: activeDetail,
          meta: {
              title: '增材云-活动详情'
          }
        },
        // 设计市场-活动详情--参赛作品详情
        {
          path: '/worksDetails/:uuid?/:activityUuid?',
          name: 'worksDetails',
          component: worksDetails,
          meta: {
              title: '增材云-参赛作品详情'
          }
        },
        // 设计市场-活动详情--获奖作品详情
        {
          path: '/winDetails',
          name: 'winDetails',
          component: winDetails,
          meta: {
              title: '增材云-获奖作品详情'
          }
        },
        // 设计市场-活动详情--领导中心
        {
          path: '/leaderList',
          name: 'leaderList',
          component: leaderList,
          meta: {
              title: '增材云-领导中心'
          }
        },
        // 设计市场-成果详情页
        {
            path: '/productWork',
            name: 'productWork',
            component: productWork,
            meta: {
                title: '增材云-设计市场'
            }
        },
        // 模型库
        {
            path: '/model',
            name: 'model',
            component: model,
            meta: {
                title: '增材云—3D模型库'
            }
        },
        // 模型库详情页
        {
            path: '/modelDetails',
            name: 'modelDetails',
            component: ModelDetails,
            meta: {
                title: '增材云—3D模型库'
            }
        },
        // 模型库列表页
        {
            path: '/modelList',
            name: 'modelList',
            component: ModelList,
            meta: {
                title: '增材云—3D模型库'
            }
        },
		
		// 模型库2d转3d
		{
		    path: '/modelImage',
		    name: 'modelImage',
		    component: modelImage,
		    meta: {
		        title: '增材云—3D模型库'
		    }
		},
        // 3D商城
        {
            path: '/mall',
            name: 'mall',
            component: mall,
            meta: {
                title: '增材云—3D商城'
            }
        },
        // 我的购物车
        {
            path: '/shopCar',
            name: 'shopCar',
            component: shopCar,
            meta: {
                title: '增材云—我的购物车'
            }
        },
        // 3D商城-商品列表页
        {
            path: '/shopGoodsList/:uuid?/:secondUuid?/:thirdUuid?',
            name: 'shopGoodsList',
            component: ShopGoodsList,
            meta: {
                title: '增材云—3D商城'
            }
        },
        // 3D商城-商品详情
        {
            path: '/shopGoodDetails/:uuid',
            name: 'shopGoodDetails',
            component: ShopGoodDetails,
            meta: {
                title: '增材云—3D商城'
            }
        },
        // 立即购买
        {
            path: '/shopAffirmOrder',
            name: 'shopAffirmOrder',
            component: ShopAffirmOrder,
            meta: {
                title: '增材云-商城下单'
            }
        },
        // 购买成功
        {
            path: '/shopSendSuccess/:orderCode',
            name: 'shopSendSuccess',
            component: ShopSendSuccess,
            meta: {
                title: '增材云-下单成功'
            }
        },
        // 3D商城-商城列表
        {
            path: '/MallList',
            name: 'shopMallList',
            component: ShopMallList,
            meta: {
                title: '增材云—3D商城'
            }
        },
        {
            path: '/shopServiceAuthentication',
            name: 'shopServiceAuthentication',
            component: ShopServiceAuthentication,
            meta: {
                title: '增材云—商家入驻'
            }
        },
        // 软件市场
        {
            path: '/apps',
            name: 'apps',
            component: apps,
            meta: {
                title: '增材云-应用市场'
            }
        },
        // 软件超市详情页
        {
            path: '/appsDetails/:uuid',
            name: 'saasDetails',
            component: SaasDetails,
            hidden: true,
            meta: {
                title: '增材云-应用市场'
            }
        },
        // 软件超市列表页
        {
            // path: '/appsList/:tabParam/:search',
            path: '/appsList',
            name: 'saasList',
            component: SaasList,
            meta: {
                title: '增材云-应用市场'
            }
        },
        // 注册
        {
            path: '/registered',
            name: 'registered',
            component: Registered,
            meta: {
                title: '增材云-注册'
            }
        },
        // 注册成功
        {
            path: '/regSuccess',
            name: 'regSuccess',
            component: RegSuccess,
            meta: {
                title: '增材云-注册'
            }
        },
        // 发送成功
        {
            path: '/sendSuccess:demandNo',
            name: 'sendSuccess',
            component: sendSuccess,
            meta: {
                title: '增材云-发布成功'
            }
        },

        // 登录
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                title: '增材云-登录'
            },
        },
        // 登录跳转的空页面
        {
            path: '/loginCode',
            name: 'loginCode',
            component: LoginCode,
            meta: {
                title: '增材云-登录'
            },
        },
        // 忘记密码
        {
            path: '/forgetPassword',
            name: 'forgetPassword',
            component: forgetPassword,
            meta: {
                title: '增材云-忘记密码'
            }
        },
        // 个人中心
        {
            path: '/userCenter/:userServeId',
            name: 'userCenter',
            component: UserCenter,
            meta: {
                title: '增材云-个人中心'
            }
        },
        // 个人中心--实名认证
        {
            path: '/certificationCenter',
            name: 'certificationCenter',
            component: CertificationCenter,
            meta: {
                title: '增材云-个人中心'
            }
        },
        // 个人中心--企业认证
        {
            path: '/enterCertification',
            name: 'enterCertification',
            component: EnterCertification,
            meta: {
                title: '增材云-个人中心'
            }
        },
        // 个人中心--企业管理
        {
            path: '/enterpriseCenter',
            name: 'enterpriseCenter',
            component: EnterpriseCenter,
            meta: {
                title: '增材云-个人中心'
            }
        },
        // 403页面
        {
            path: '/undefined',
            name: 'undefined',
            component: Undefined,
            meta: {
                title: '增材云-403页面'
            }
        },
        // 在线咨询
        {
            path: '/onlineConsult',
            name: 'onlineConsult',
            component: onlineConsult,
            meta: {
                title: '增材云-在线咨询'
            }
        },
        // 帮助中心
        {
            path: '/helpCenter',
            name: 'helpCenter',
            component: helpCenter,
            meta: {
                title: '增材云-帮助中心'
            }
        },
        // 帮助中心详情
        {
            path: '/helpCenterDetail',
            name: 'helpCenterDetail',
            component: helpCenterDetail,
            meta: {
                title: '增材云-帮助中心详情页'
            }
        },
        {
            path: '/shelves',
            name: 'shelves',
            component: shelves,
            meta: {
                title: '商品下架'
            }
        },
        {
            path: '/integralActivities/:uuid',
            name: 'integralActivities',
            component: integralActivities,
            meta: {
                title: '积分活动'
            }
        },
        {
            path: '/activeShopGoodDetails',
            name: 'activeShopGoodDetails',
            component: activeShopGoodDetails,
            meta: {
                title: '积分活动商品详情'
            }
        },
        // 立即购买
        {
            path: '/activeShopAffirmOrder',
            name: 'activeShopAffirmOrder',
            component: activeShopAffirmOrder,
            meta: {
                title: '积分活动商品下单'
            }
        },
        // 购买成功
        {
            path: '/activeShopSendSuccess/:orderCode',
            name: 'activeShopSendSuccess',
            component: activeShopSendSuccess,
            meta: {
                title: '积分活动商品下单成功'
            }
        },
        {
            path: '/collectActivities/:uuid',
            name: 'collectActivities',
            component: collectActivities,
            meta: {
                title: '集采活动'
            }
        },
        {
            path: '/collectShopGoodDetails',
            name: 'collectShopGoodDetails',
            component: collectShopGoodDetails,
            meta: {
                title: '集采活动商品详情'
            }
        },
        // 立即购买
        {
            path: '/collectShopAffirmOrder',
            name: 'collectShopAffirmOrder',
            component: collectShopAffirmOrder,
            meta: {
                title: '集采活动商品下单'
            }
        },
        // 购买成功
        {
            path: '/collectShopSendSuccess/:orderCode',
            name: 'collectShopSendSuccess',
            component: collectShopSendSuccess,
            meta: {
                title: '集采活动商品下单成功'
            }
        },
        // 3D建模大赛
        {
            path: '/threeDModel',
            name: 'threeDModel',
            component: threeDModel,
            meta: {
                title: '3D建模大赛'
            }
        },
        
    ]
})

router.beforeEach((to, from, next) => {
    let path = to.fullPath
    if (path != '/undefined') {
        store.commit('vuexAllPark', true)
    } else {

    }
    if( from.name == 'login' && to.name == 'printPlaceAnOrder'){
        next('/print')
    }
    store.commit('routerPathVuex', path)
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js